import React, { useEffect, useState } from "react";
import api from "../lib/api";
import FeaturedHero from "../components/FeaturedHero";
import NewsCard from "../components/NewsCard";
import { Link } from "react-router-dom";
import { ArrowRight, Flame, Users } from "lucide-react";

export default function Home() {
  const [news, setNews] = useState([]);
  const [trending, setTrending] = useState([]);

useEffect(() => {
  (async () => {
    try {
      const [a, b] = await Promise.all([
        api.get("/news?limit=20"),
        api.get("/news/trending"),
      ]);

      setNews(a.data || []);
      setTrending(b.data || []);
    } catch (err) {
      console.error("Home API failed:", err);
      setNews([]);
      setTrending([]);
    }
  })();
}, []);

  const featured = news.find((n) => n.featured) || news[0];
  const rest = news.filter((n) => n.id !== featured?.id);
  const byCat = (slug) => rest.filter((n) => n.category_slug === slug).slice(0, 3);

  return (
    <div className="pt-24 pb-16">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8">
            <FeaturedHero article={featured} />
          </div>
          <aside className="lg:col-span-4 bg-[#0a0a0b] border border-white/10 p-6" data-testid="trending-sidebar">
            <div className="flex items-center gap-2 mb-6">
              <Flame className="w-4 h-4 text-yellow-400" />
              <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Trending now</h3>
            </div>
            <ol className="space-y-5">
              {trending.slice(0, 6).map((t, i) => (
                <li key={t.id} className="flex gap-4 group">
                  <span className="font-display text-3xl font-bold text-zinc-700 group-hover:text-yellow-400 transition">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <Link
                    to={`/news/${t.id}`}
                    data-testid={`trending-item-${t.id}`}
                    className="text-sm text-zinc-200 group-hover:text-yellow-400 transition leading-snug"
                  >
                    {t.title}
                  </Link>
                </li>
              ))}
            </ol>
          </aside>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 mt-20">
        <div className="flex items-end justify-between mb-8">
          <h2 className="font-display font-bold text-3xl md:text-4xl text-white tracking-tight">Latest News</h2>
          <Link to="/news" className="text-sm font-mono uppercase tracking-widest text-yellow-400 hover:underline" data-testid="see-all-news">
            See all <ArrowRight className="inline w-3 h-3" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.slice(0, 6).map((n) => (
            <NewsCard key={n.id} article={n} />
          ))}
        </div>
      </section>

      {[
        { slug: "bitcoin", label: "Bitcoin" },
        { slug: "ethereum", label: "Ethereum" },
        { slug: "altcoins", label: "Altcoins" },
        { slug: "market-analysis", label: "Market Analysis" },
      ].map((cat) => {
        const items = byCat(cat.slug);
        if (!items.length) return null;
        return (
          <section key={cat.slug} className="max-w-[1400px] mx-auto px-6 md:px-10 mt-20">
            <div className="flex items-end justify-between mb-8 border-b border-white/10 pb-4">
              <h2 className="font-display font-bold text-2xl md:text-3xl text-white">
                <span className="text-yellow-400">/</span> {cat.label}
              </h2>
              <Link
                to={`/categories/${cat.slug}`}
                data-testid={`cat-link-${cat.slug}`}
                className="text-xs font-mono uppercase tracking-widest text-zinc-400 hover:text-yellow-400"
              >
                More →
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {items.map((n) => <NewsCard key={n.id} article={n} />)}
            </div>
          </section>
        );
      })}

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 mt-24">
        <div className="relative bg-[#0a0a0b] border border-white/10 p-10 md:p-16 overflow-hidden">
          <div className="absolute inset-0 opacity-20" style={{
            backgroundImage:
              "radial-gradient(circle at 20% 50%, #facc15 0%, transparent 40%), radial-gradient(circle at 80% 30%, #3b82f6 0%, transparent 40%)",
          }} />
          <div className="relative max-w-2xl">
            <Users className="w-8 h-8 text-yellow-400 mb-4" />
            <h2 className="font-display font-bold text-4xl md:text-5xl text-white tracking-tight">
              Join the HashRate Community.
            </h2>
            <p className="mt-4 text-zinc-300 text-lg">
              Share alpha, debate macro, and build with traders, developers, and analysts who care about signal.
            </p>
            <Link to="/community" data-testid="cta-community-link">
              <button className="mt-8 bg-yellow-400 text-black font-bold uppercase tracking-wide px-8 py-4 hover:bg-yellow-500 transition">
                Enter the Feed →
              </button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
